import { combineReducers } from "redux"
import { login,singIn } from "./loginReducer"

const authReducers = combineReducers({
  login,
  singIn
})

export default authReducers
